/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wsc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. All cleaning happens in your browser; your text is never sent to a server.`)
};

const es_wsc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Toda la limpieza ocurre en tu navegador; tu texto nunca se envía a un servidor.`)
};

const de_wsc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Die gesamte Bereinigung erfolgt in Ihrem Browser; Ihr Text wird niemals an einen Server gesendet.`)
};

const nl_wsc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Alle opruiming gebeurt in uw browser; uw tekst wordt nooit naar een server gestuurd.`)
};

const fr_wsc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Tout le nettoyage se fait dans votre navigateur ; votre texte n'est jamais envoyé à un serveur.`)
};

const it_wsc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Tutta la pulizia avviene nel tuo browser; il tuo testo non viene mai inviato a un server.`)
};

const pt_br2_wsc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Toda a limpeza acontece no seu navegador; seu texto nunca é enviado para um servidor.`)
};

const pt_wsc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Toda a limpeza acontece no seu navegador; o seu texto nunca é enviado para um servidor.`)
};

const ja_wsc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。すべてのクリーニングはブラウザで実行されます。テキストはサーバーに送信されません。`)
};

const zh_wsc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。所有清理都在您的浏览器中完成；您的文本永远不会发送到服务器。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wsc_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wsc_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wsc_faq3_a", locale)
	if (locale === "en") return en_wsc_faq3_a(inputs)
	if (locale === "es") return es_wsc_faq3_a(inputs)
	if (locale === "de") return de_wsc_faq3_a(inputs)
	if (locale === "nl") return nl_wsc_faq3_a(inputs)
	if (locale === "fr") return fr_wsc_faq3_a(inputs)
	if (locale === "it") return it_wsc_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_wsc_faq3_a(inputs)
	if (locale === "pt") return pt_wsc_faq3_a(inputs)
	if (locale === "ja") return ja_wsc_faq3_a(inputs)
	return zh_wsc_faq3_a(inputs)
};